<div class="project-card" [style.background-image]="'url()'">
    <img class="contain-image" src="/assets/da-keeree-04.gif">
    <h2 class="coming-soon">Coming Soon</h2>
</div>